import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, ViewChild, computed, input, output } from '@angular/core';
import { ToastConfig } from '../toast.service';

@Component({
    selector: 'nexus-toast',
    imports: [NgClass],
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastComponent {
  toast = input.required<ToastConfig>();

  toastClass = computed(() => {
    switch(this.toast().color) {
      case 'danger': return 'text-bg-danger border-0';
      case 'primary': return 'text-bg-primary border-0';
      default: return 'text-body';
    }
  });

  hidden = output();

  @ViewChild('toastElement') toastRef!: ElementRef;

  bootstrapRef: any;

  private readonly destroySignal = new AbortController();

  ngAfterViewInit() {
    this.bootstrapRef = (window as any).bootstrap?.Toast?.getOrCreateInstance(this.toastRef.nativeElement,
      {
        delay: this.toast().delay,
        autohide: !this.toast().ongoing,
      }
    )
    this.bootstrapRef?.show();

    this.toastRef.nativeElement.addEventListener('hidden.bs.toast',
      () => {
        this.hidden.emit();
      },
      {signal: this.destroySignal.signal}
  );
  }

  ngOnDestroy() {
    this.destroySignal.abort();
    try {
      this.bootstrapRef?.dispose();
    } catch {}
  }
}
